import Animate from './Animate';
import AnimateChild from './AnimateChild';
import CSSMotion from './CSSMotion';

export { AnimateChild, CSSMotion };

export default Animate;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree/node_modules/rc-animate/es/index.js
// module id = 1626
// module chunks = 0